import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, InvoiceService, UserService} from '../_services';
import {CrudSavePopupComponent} from '../_directives';
import {FormBuilder} from '@angular/forms';
import {Invoice, User} from "../_models";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {parseISODateString} from "../_helpers";

@Component({
  moduleId: module.id.toString(),
  selector: 'invoice-billing-date-form',
  templateUrl: './invoice-billing-date.component.html'
})
export class InvoiceBillingDateComponent extends CrudSavePopupComponent implements OnInit {
  invoice: Invoice;
  billingStartDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  billingStartDateDisplayString = '';
  ngModelOptions = {standalone: true};
  user: User;

  constructor(protected router: Router,
              protected location: Location,
              protected route: ActivatedRoute,
              protected formBuilder: FormBuilder,
              protected invoiceService: InvoiceService,
              protected alertService: AlertService,
              private userService: UserService
  ) {
    super(router, location, route, invoiceService, alertService);
    this.objectName = 'Invoice';
  }

  ngOnInit() {
    this.setForm(this.formBuilder.group({
    }));

    super.ngOnInit();
  }

  protected onInputDataChanged() {
    this.invoice = this.inputData;

    if (this.invoice) {
      this.userService.getCurrent()
        .subscribe(
          (user: User) => {
            this.user = user;
            const billingStartDate = parseISODateString(this.invoice.billing_start_date);
            const maxDate = parseISODateString(this.user.account.billing_start_date);

            this.billingStartDate = {
              year: billingStartDate.getUTCFullYear(),
              month: billingStartDate.getUTCMonth() + 1,
              day: billingStartDate.getUTCDate()
            };
            this.maxDate = {
              year: maxDate.getUTCFullYear(), month: maxDate.getUTCMonth() + 1, day: maxDate.getUTCDate()
            };
            this.billingStartDateDisplayString = billingStartDate.toLocaleDateString("en-US", {timeZone: 'UTC'});
          },
          error => {
            this.handleError(error);
          }
        );
    }
  }

  parseBillingStartDate(dateStruct: NgbDateStruct) {
    if (dateStruct) {
      const date = new Date(dateStruct.year, dateStruct.month - 1, dateStruct.day);

      if (date) {
        this.billingStartDateDisplayString = date.toLocaleDateString("en-US", {timeZone: 'UTC'});
        this.billingStartDate = dateStruct;
      }
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.valid) {
      if (this.billingStartDate) {
        const billingStartDate = this.billingStartDate.year + '-' + this.billingStartDate.month + '-' + this.billingStartDate.day
        this.invoiceService.setBillingStartDate(this.invoice.id, billingStartDate)
          .subscribe(
            data => {
              this.alertService.success('Invoice billing start date changed to ' + this.billingStartDateDisplayString);
              this.onSaveComplete(data);
            },
            error => {
              this.handleSubmitError(error);
              this.loading = false;
            });
      }
    }
  }

}
